exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ng-valid[required], .ng-valid.required {\n  border-left: 5px solid #42A948;\n  /* green */ }\n\n.form-control.ng-invalid.ng-touched {\n  border-left: 5px solid #e30613;\n  /* red */ }\n\n#contact-form {\n  margin-top: 5%; }\n\n.form-control {\n  border-radius: 0;\n  border: 0;\n  background-color: #ededed;\n  color: #575756;\n  height: 40px;\n  box-shadow: none; }\n\ntextarea.form-control {\n  height: 235px; }\n\n.form-group {\n  margin-bottom: 25px; }\n\n.btn-red {\n  background-color: #e30613;\n  border-radius: 0;\n  border: 0;\n  color: #fff;\n  font-size: larger; }\n  .btn-red:hover {\n    font-size: larger;\n    color: #fff;\n    background-color: #b1050f;\n    border-radius: 0;\n    border: 0; }\n\n.alert {\n  border-radius: 0; }\n  .alert .alert-danger {\n    color: #e30613; }\n\ninput, textarea {\n  position: relative;\n  font-family: 'Open Sans', monospace; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /media/webdesign/5E0ECC7B0ECC4E29/www/leasytool/src/app/contact/contact.component.scss
// module id = ../../../../../src/app/contact/contact.component.scss
// module chunks = 1